import { map } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import Muncher from '.'

export default class Pie extends Muncher {
  /**
   * call - This method returns the data structure to print a line chart
   *
   * @method
   */
  call() {
    const { primaryField, secondaryField, tertiaryField } = this.query.fields

    const notDefined = i18n.t(`custom_reports.value_not_defined`)

    const initialData = primaryField
    const secondaryData = !tertiaryField ? secondaryField : tertiaryField

    return map(this.data, (row: any) => {
      const label = row[secondaryData] || notDefined

      return {
        id: label,
        value: row[initialData],
        label: label,
      }
    })
  }
}
